/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Checkbox, Col, Form, Radio, Row, Switch } from "antd";
import IconFieldWorkflow from "../../../../../atoms/CustomIcons/IconFieldWorkflow";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import { AxiosError } from "axios";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { updateCompanySettings } from "../../ducks/services";
import { useEffect, useState } from "react";
import { getCompanyFieldsById } from "../../../TagsCategories/ducks/actions";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import { useForm } from "react-hook-form";

export default function FieldWorkflow({
  setLoading,
}: {
  setLoading: (loading: boolean) => void;
}) {
  const { handleSubmit, setValue } = useForm();

  const [routeOption, setRouteOption] = useState<string>("ZIG_ZAG");
  const [confirmWorkOrders, setConfirmWorkOrders] = useState<boolean>(false);
  const [approveWorkOrders, setApproveWorkOrders] = useState<boolean>(false);
  const [timeTracking, setTimeTracking] =
    useState<string>("PROPORTIONAL_SPLIT");
  const [timeMaterials, setTimeMaterials] = useState<boolean>(false);
  const [fixedPrice, setFixedPrice] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];

  const settingsData = useAppSelector((state) => state?.tags?.tagData);

  useEffect(() => {
    if (companyId && serviceLineId) {
      const payload = {
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "FIELD_WORK_FLOW",
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId, serviceLineId]);

  useEffect(() => {
    if (settingsData) {
      const routingMethod: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "ROUTING_METHOD"
      );
      const finishedWorkData: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "APPROVAL_REQUIRED_FOR_FINISHED_WORK_ORDERS_ENABLED"
      );
      const fixedPriceData: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "APPROVE_BILLING_FIXED_PRICE_WORK_ORDERS_ENABLED"
      );
      const timeMaterialsData: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "APPROVE_BILLING_TIME_MATERIAL_WORK_ORDERS_ENABLED"
      );
      const timeTrackingData: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "TIME_TRACKING_METHOD_FOR_VISIT_WORK_ORDERS"
      );

      if (routingMethod) {
        setRouteOption(routingMethod?.value);
      }
      if (finishedWorkData) {
        setConfirmWorkOrders(finishedWorkData?.value);
      }
      if (fixedPriceData || timeMaterialsData) {
        setFixedPrice(fixedPriceData?.value ?? "");
        setTimeMaterials(timeMaterialsData?.value ?? "");
        setApproveWorkOrders(fixedPriceData?.value);
      }
      if (timeTrackingData) {
        setTimeTracking(timeTrackingData?.value);
      }
    }
  }, [settingsData, setValue]);

  const onSubmit = (data: any) => {
    console.log("Form Data:", data);

    setLoading(true);
    const payload = [];

    if (routeOption) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "FIELD_WORK_FLOW",
        name: "ROUTING_METHOD",
        value: routeOption,
      });
    }

    if (confirmWorkOrders !== undefined) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "FIELD_WORK_FLOW",
        name: "APPROVAL_REQUIRED_FOR_FINISHED_WORK_ORDERS_ENABLED",
        value: confirmWorkOrders.toString(),
      });
    }

    if (fixedPrice) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "FIELD_WORK_FLOW",
        name: "APPROVE_BILLING_FIXED_PRICE_WORK_ORDERS_ENABLED",
        value: fixedPrice.toString(),
      });
    }

    if (timeMaterials) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "FIELD_WORK_FLOW",
        name: "APPROVE_BILLING_TIME_MATERIAL_WORK_ORDERS_ENABLED",
        value: timeMaterials.toString(),
      });
    }

    if (timeTracking) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "FIELD_WORK_FLOW",
        name: "TIME_TRACKING_METHOD_FOR_VISIT_WORK_ORDERS",
        value: timeTracking.toString(),
      });
    }

    updateCompanySettings(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Changes saved");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  return (
    <div style={{ width: "800px", margin: "0 auto" }}>
      <div>
        <h2 className="tabs_content_heading">
          <IconFieldWorkflow /> Field workflow
        </h2>
        <p className="tabs_content_subheading">
          Configure everything related to the work completion on properties.
        </p>
      </div>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div className="icon_avatar">
                <img
                  src="/images/settings/cs_routing.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Routing method </h3>
                <p>
                  Select a default routing method. You can change the method for
                  individual days in the schedule.
                </p>
              </div>
            </div>
          </div>
          <Radio.Group
            className="route_option_radio"
            value={routeOption}
            onChange={(e) => setRouteOption(e.target.value)}
            defaultValue="ZIG_ZAG"
          >
            <Row gutter={12}>
              <Col span={12}>
                <Radio value="ZIG_ZAG" style={{ width: "100%" }}>
                  <div className="bordered_card">
                    <h4 style={{ marginBottom: "6px" }}>
                      Route through each side separately
                    </h4>
                    <p style={{ color: "#6C7478", marginBottom: "12px" }}>
                      Regular option for most of the crews
                    </p>
                    <img src="/images/settings/route_1.svg" alt="" />
                  </div>
                </Radio>
              </Col>

              <Col span={12}>
                <Radio value="SEQUENTIAL" style={{ width: "100%" }} disabled>
                  <div className="bordered_card">
                    <h4 style={{ marginBottom: "6px" }}>
                      Visit properties on both sides
                    </h4>
                    <p style={{ color: "#6C7478", marginBottom: "12px" }}>
                      For right-hand drive sprayer truck
                    </p>
                    <img src="/images/settings/route_2.svg" alt="" />
                  </div>
                </Radio>
              </Col>
            </Row>
          </Radio.Group>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar" style={{ marginBottom: "0px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
                width: "100%",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div className="icon_avatar">
                  <img
                    src="/images/settings/icon_check.svg"
                    alt="customer management"
                  />
                </div>
                <div>
                  <h3 style={{ marginBottom: "4px" }}>
                    {" "}
                    Confirm work orders after completion{" "}
                  </h3>
                  <p>
                    Decide if {""}
                    <span style={{ color: "#6454F4", fontWeight: "600" }}>
                      production manager
                    </span>
                    {""} must confirm work orders once the crew finishes them.
                  </p>
                </div>
              </div>
              <div>
                <Switch
                  checked={confirmWorkOrders}
                  onChange={setConfirmWorkOrders}
                  disabled
                />
              </div>
            </div>
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
                width: "100%",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div className="icon_avatar">
                  <img
                    src="/images/settings/icon_stamp.svg"
                    alt="customer management"
                  />
                </div>
                <div>
                  <h3 style={{ marginBottom: "4px" }}>
                    {" "}
                    Approve work orders before billing{" "}
                  </h3>
                  <p>
                    Decide if{" "}
                    <span style={{ color: "#6454F4", fontWeight: "600" }}>
                      branch manager
                    </span>{" "}
                    must approve work order before billing. This can be
                    customized per client and per each work order.
                  </p>
                </div>
              </div>
              <div>
                <Switch
                  checked={approveWorkOrders}
                  onChange={setApproveWorkOrders}
                  disabled
                />
              </div>
            </div>
          </div>
          <div>
            <p
              style={{
                marginBottom: "8px",
                display: "flex",
                gap: "6px",
                alignItems: "center",
              }}
            >
              <Checkbox
                checked={fixedPrice}
                onChange={(e: any) => setFixedPrice(e.target.checked)}
              />{" "}
              Fixed-price contracts
            </p>
            <p style={{ display: "flex", gap: "6px", alignItems: "center" }}>
              <Checkbox
                checked={timeMaterials}
                onChange={(e: any) => setTimeMaterials(e.target.checked)}
              />{" "}
              Time & material contracts
            </p>
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div className="icon_avatar">
                <img
                  src="/images/settings/icon_timer.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Time tracking for multiple work orders </h3>
                <p>
                  Choose how crew leaders and technicians track time when a
                  visit includes multiple work orders.
                </p>
              </div>
            </div>
          </div>
          <Radio.Group
            className="tracking_option_radio"
            value={timeTracking}
            onChange={(e) => setTimeTracking(e.target.value)}
          >
            <Row style={{ marginBottom: "12px" }}>
              <Col span={24}>
                <Radio value="PROPORTIONAL_SPLIT" style={{ width: "100%" }}>
                  <div className="bordered_card">
                    <h4 style={{ marginBottom: "6px" }}>
                      {" "}
                      Proportional split{" "}
                    </h4>
                    <p style={{ color: "#6C7478", marginBottom: "12px" }}>
                      Crew leaders log total visit time. The system
                      automatically divides it among work orders based on
                      estimated durations.
                    </p>
                    <ul>
                      <li> Easier for crew leaders </li>
                      <li> Less precise per work order and per person </li>
                    </ul>
                  </div>
                </Radio>
              </Col>
            </Row>
            <Row style={{ marginBottom: "12px" }}>
              <Col span={24}>
                <Radio value="BEFORE_WORK_STARTS" style={{ width: "100%" }}>
                  <div className="bordered_card">
                    <h4 style={{ marginBottom: "6px" }}>
                      {" "}
                      Before work starts{" "}
                    </h4>
                    <p style={{ color: "#6C7478", marginBottom: "12px" }}>
                      Crew leaders assign each person to a work order and clock
                      them in separately.
                    </p>
                    <ul>
                      <li> Precise per person and work order </li>
                      <li>
                        Requires crew leaders to switch people in the app during
                        the visit if they change tasks
                      </li>
                    </ul>
                  </div>
                </Radio>
              </Col>
            </Row>
            {/* <Row style={{ marginBottom: "0px" }}>
              <Col span={24}>
                <Radio value="AFTER_VISIT_ENDS" style={{ width: "100%" }}>
                  <div className="bordered_card">
                    <h4 style={{ marginBottom: "6px" }}> After visit ends </h4>
                    <p style={{ color: "#6C7478", marginBottom: "12px" }}>
                      Crew leaders log total visit time, then assign time and
                      people to work orders afterward.
                    </p>
                    <ul>
                      <li> Precise per person and work order </li>
                      <li> No distraction during the visit </li>
                      <li>
                        Relies on crew leader’s memory and accurate entry
                        afterward
                      </li>
                    </ul>
                  </div>
                </Radio>
              </Col>
            </Row> */}
          </Radio.Group>
        </Card>

        <div style={{ textAlign: "right", width: "100%" }}>
          <Button
            htmlType="submit"
            className="mint-btn"
            style={{ marginTop: "10px" }}
          >
            Save changes
          </Button>
        </div>
      </Form>
    </div>
  );
}
